import { Component, OnInit, ViewChild } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { MatChipInputEvent } from '@angular/material/chips';
import { COMMA, ENTER, W } from '@angular/cdk/keycodes';
@Component({
  selector: 'app-createcustomfrom',
  templateUrl: './createcustomfrom.component.html',
  styleUrls: ['./createcustomfrom.component.css']
})
export class CreatecustomfromComponent implements OnInit {
  @ViewChild('closebutton') closebutton;
  addCustomForm: FormGroup
  modalFormFields: FormGroup
  fieldsOptions: any;
  filedsOptionsArry: any;
  isShowModelFormPreview: boolean;
  customData = [];
  dataSorce:any = []
  addNewObject: any = {}
  readonly separatorKeysCodes: number[] = [ENTER, COMMA];
  isFormShowHide: boolean;
  istexAreaHide: boolean;
  isHidePlaceHolder: boolean;
  isCharacter: boolean;
  isDate: boolean;
  isNumbers: boolean;
  isShowfielsOptionValues: boolean;
  isShowSelectOptions: boolean;
  fields = ['text', 'textarea', 'date', 'checkbox', 'radio', 'dropdown'];
  constructor(public formBuilder: FormBuilder) { }

  ngOnInit(): void {
    this.customFormLoad()
    this.fieldFormLoad()
  }
  customFormLoad() {
    this.addCustomForm = new FormGroup({
      branch: new FormControl('', Validators.required),
      employee: new FormControl('', Validators.required)

    })
  }
  public checkError = (controlName: string, errorName: string) => {
    return this.addCustomForm.controls[controlName].hasError(errorName);
  }
  onSubmit() {
    console.log(this.addCustomForm.value)
  }
  fieldFormLoad() {
    this.modalFormFields = this.formBuilder.group({
      label: ['', [Validators.required]],
      type: ['', [Validators.required]],
      name: [Math.random() * 100],
      textType: [''],
      required: [''],
      placeholder: [''],
      // formatValidation: [''],
      options: [''],
      multiselect: [''],
      hint: [''],
      characterLength: [''],
      sizemax: [''],
      sizemin: [''],
      // historyDate:[''],
      // futureDate:[''],
      historyFutureDate: [''],
      col: ['col-md-12'],
      multiline: [false]
    });
  }
  addFieldsSet(event: MatChipInputEvent): void {
    console.log(event);
    if (event.value.length != 0) {
      // console.log(event.value.length != 0)
      // this.filedsOptionsArry.push(event.value)
      // console.log(this.filedsOptionsArry)
      // this.AddOnchangeFormPreview(this.filedsOptionsArry, 'options')
      // alert('fun')

    }
    const input = event.input;
    const value = event.value;

    // Add our fruit
    if ((value || '').trim()) {
      // this.actions.push({ name: value.trim() });
      this.fieldsOptions.push({ name: value.trim() });
      // console.log(this.fieldsOptions)
      this.AddOnchangeFormPreview(this.fieldsOptions, 'options');
    }

    // Reset the input value
    if (input) {
      input.value = '';
    }
  }
  searchValue(e:any){
    
  }
  removeFieldsSet(val): void {
    const id = this.filedsOptionsArry.indexOf(val.name);


    const index = this.fieldsOptions.indexOf(val);
    // console.log(val.name, this.filedsOptionsArry.indexOf(val.name), this.filedsOptionsArry)
    if (index >= 0) {
      this.fieldsOptions.splice(index, 1);
      this.filedsOptionsArry.splice(id, 1);
    }
    // console.log(this.filedsOptionsArry)
    // this.onchangeFormPreview(this.filedsOptionsArry, 'options-remove')
  }
  addModelOptions(event: any) {
    this.customData.pop();
    const objKey = Object.keys(this.addNewObject);
    this.isFormShowHide = false;
    this.fieldsOptions = [];
    for (const key of objKey) {
      if (key != 'type') {
        delete this.addNewObject[key];
      }
    }
    const objKey1 = Object.keys(this.modalFormFields.value);
    this.isFormShowHide = false;
    for (const key of objKey1) {
      if (key != 'type') {
        this.modalFormFields.controls[key].reset();
      }
    }
    this.enableDisableFields(event.value);
    this.isFormShowHide = true;
    this.addNewObject.type = event.value;
    this.addNewObject.value = '';
    // if (event.value == 'date') {
    //     this.addNewObject['value'] = ''
    // } else {
    //     delete this.addNewObject['value']
    // }
    if (event.value == 'checkbox' || event.value == 'radio' || event.value == 'dropdown') {
      this.addNewObject.options = [];
    } else {
      delete this.addNewObject.options;
    }
    // console.log(this.addNewObject)

  }
  AddOnchangeFormPreview(event: any, name: string) {
    this.addNewObject[name] = event.value;
    if (name == 'required') { this.addNewObject[name] = event.checked; }
    if (name == 'multiselect') { this.addNewObject[name] = event.checked; }
    if (name == 'sizemin') { }
    // if (name == 'sizemax') {
    //     console.log(this.addNewObject['sizemin'],
    //         this.addNewObject['sizemax'])
    //     if (this.addNewObject['sizemin'] > this.addNewObject['sizemax']) {
    //         alert('sizemax')
    //         this.addNewObject['sizemax'] = ''
    //     }
    // }
    if (name == 'options') {
      const obj = [];
      event.forEach(element => {
        obj.push({ name: element.name, value: element.name });
      });
      // console.log(obj)
      this.addNewObject.options = obj;
    }
    if (name == 'text' || name == 'textare' || name == 'date') {

      delete this.addNewObject.options;
    }
    if (name == 'textType') {
      // console.log(event, name, 'textType')
      this.isCharacter = false;
      this.isNumbers = false;
      if (event.value == 'text') {
        this.isCharacter = true;
      }
      if (event.value == 'number') {
        this.isNumbers = true;
      }
    }
    // console.log(this.addNewObject)
    this.customData.pop();
    this.customData.push(this.addNewObject);
    this.addNewObject.name = '';
    // console.log(this.customData, 'final data')
    this.isShowModelFormPreview = true;
  }
  enableDisableFields(type) {
    // console.log(type, 'enabel disabe')
    this.istexAreaHide = false;
    this.isHidePlaceHolder = false;
    this.isCharacter = false;
    this.isDate = false;
    this.isNumbers = false;
    this.isShowfielsOptionValues = false;
    this.isShowSelectOptions = false;
    if (type == 'text') {
      this.istexAreaHide = true;
      this.isHidePlaceHolder = true;
      this.isCharacter = true;
    } else if (type == 'textarea') {
      this.isHidePlaceHolder = true;
      this.isCharacter = true;
    } else if (type == 'date') {
      this.isDate = true;
    } else if (type == 'radio') {
      this.isShowfielsOptionValues = true;
    } else if (type == 'checkbox') {
      this.isShowfielsOptionValues = true;
    } else if (type == 'dropdown') {
      this.isShowfielsOptionValues = true;
      this.isShowSelectOptions = true;
    }
  }
  onModalFormSubmit() {
   
    if (this.modalFormFields.invalid) {
      return // Process your form
    }
    

this.dataSorce.push(this.clean(this.modalFormFields.value))
console.log(this.dataSorce,'obj',this.addNewObject)
// this.modalFormFields.reset();
this.modelClose()
  }
  clean(obj) {
    for (var propName in obj) {
      if (obj[propName] === null || obj[propName] === undefined) {
        delete obj[propName];
      }
    }
    return obj
  }
  modelClose() {
    this.modalFormFields.reset();
    this.fieldsOptions = [];
    this.closebutton.nativeElement.click();
}
}
